// extracted by mini-css-extract-plugin
export var container = "TagsMob-module--container--25FHR";
export var container__tags = "TagsMob-module--container__tags--PKIGZ";
export var container__tags__item = "TagsMob-module--container__tags__item--Ekkj4";
export var container__tags__item__button = "TagsMob-module--container__tags__item__button--t0x14";
export var fadeIn = "TagsMob-module--fadeIn--k0GR8";
export var fadeOut = "TagsMob-module--fadeOut--aLttz";
export var overlay = "TagsMob-module--overlay--kpIF9";